module.exports = __webpack_public_path__ + "media/images/front/varieties/VALENCIA-LATE-96bd38d08f3c2deabb1298efc8c7ec13.jpg";